import { initializeApp } from "firebase/app";

const firebaseConfig_refined = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || process.env.FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "booker-main.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "booker-main",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "booker-main.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || process.env.MESSAGING_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || process.env.APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || process.env.MEASUREMENT_ID
};


const app_connection = initializeApp(firebaseConfig_refined);

export default app_connection
